import 'core-js';

import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import { App } from "./app";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root") as HTMLElement
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx